import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  FormatColorFill as HighlightIcon,
  Search as SearchIcon,
  VolumeUp as VolumeUpIcon
} from '@mui/icons-material';

const getButtonSx = ({ active, activeColor, compact }) => ({
  color: active ? activeColor : compact ? 'text.secondary' : 'inherit',
  '&:hover': compact ? { color: activeColor } : undefined
});

const ArticleModalReadingTools = ({
  compact,
  highlightEnabled,
  isSearchOpen,
  isSpeaking,
  isPaused,
  isTTSSupported,
  onListen,
  onOpenSearch,
  onToggleHighlight,
  showHighlight
}) => {
  const iconSize = compact ? 18 : 22;
  const buttonSize = compact ? 'small' : 'medium';

  const controls = (
    <>
      <Tooltip title="Pesquisar no conteúdo (Ctrl+F)" arrow>
        <IconButton
          size={buttonSize}
          onClick={onOpenSearch}
          sx={getButtonSx({ active: isSearchOpen, activeColor: 'primary.main', compact })}
        >
          <SearchIcon sx={{ fontSize: iconSize }} />
        </IconButton>
      </Tooltip>

      {showHighlight && (
        <Tooltip title={highlightEnabled ? 'Desativar Marca-texto' : 'Ativar Marca-texto'} arrow>
          <IconButton
            size={buttonSize}
            onClick={onToggleHighlight}
            sx={getButtonSx({ active: highlightEnabled, activeColor: 'warning.main', compact })}
          >
            <HighlightIcon sx={{ fontSize: iconSize }} />
          </IconButton>
        </Tooltip>
      )}

      {isTTSSupported && (
        <Tooltip title={isSpeaking ? (isPaused ? 'Continuar' : 'Pausar') : 'Ouvir Artigo'} arrow>
          <IconButton
            size={buttonSize}
            onClick={onListen}
            sx={getButtonSx({ active: isSpeaking, activeColor: 'primary.main', compact })}
          >
            <VolumeUpIcon sx={{ fontSize: iconSize }} />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  if (!compact) return controls;

  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 0.5,
        mb: 1,
        mt: 1
      }}
    >
      {controls}
    </Box>
  );
};

ArticleModalReadingTools.propTypes = {
  compact: PropTypes.bool,
  highlightEnabled: PropTypes.bool.isRequired,
  isPaused: PropTypes.bool.isRequired,
  isSearchOpen: PropTypes.bool.isRequired,
  isSpeaking: PropTypes.bool.isRequired,
  isTTSSupported: PropTypes.bool.isRequired,
  onListen: PropTypes.func.isRequired,
  onOpenSearch: PropTypes.func.isRequired,
  onToggleHighlight: PropTypes.func.isRequired,
  showHighlight: PropTypes.bool
};

ArticleModalReadingTools.defaultProps = {
  compact: false,
  showHighlight: true
};

export default ArticleModalReadingTools;
